// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"95":"edd6efd0","283":"98b67e09","308":"b91da29a","355":"27924247","824":"0cf30468","851":"2171e0e1"}[chunkId] + ".chunk.js";
};